import { Document, Page, Text, View, Image } from "@react-pdf/renderer";
import { styles as base } from "./styles/PdfStyles";
import hardcodedLogo from "../../assets/img/hardcoded-logos/mc-business.jpg";

const safe = (v) => (v == null ? "" : String(v));

const hasValue = (arr, value) => {
  if (!Array.isArray(arr)) return false;
  return arr.some((x) => (typeof x === "string" ? x === value : x?.value === value));
};

const altChecked = (arr, altText) =>
  hasValue(arr, "altul") || (altText && String(altText).trim().length > 0);

const isSafeImageSrc = (src) => {
  if (!src || typeof src !== "string") return false;
  return (
    src.startsWith("data:image/") ||
    src.startsWith("/") ||
    src.startsWith("http://localhost") ||
    src.startsWith("https://localhost")
  );
};

function Checkbox({ checked, label }) {
  return (
    <View style={{ flexDirection: "row", alignItems: "center", marginBottom: 6 }}>
      <View
        style={{
          width: 12,
          height: 12,
          borderWidth: 1,
          borderColor: "#111827",
          marginRight: 8,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {checked ? (
          <View style={{ width: 7, height: 7, backgroundColor: "#16a34a" }} />
        ) : null}
      </View>
      <Text style={{ fontSize: 11 }}>{label}</Text>
    </View>
  );
}

function Line({ label, value, lineWidth = 230 }) {
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "baseline",
        marginBottom: 6,
        flexWrap: "wrap",
      }}
    >
      <Text style={{ fontSize: 11 }}>{label}</Text>
      <Text style={{ fontSize: 11, textDecoration: "underline", textDecorationStyle: "dotted" }}>
        {"  "}
        {value && String(value).trim()
          ? String(value)
          : " ".repeat(Math.max(10, Math.floor(lineWidth / 10)))}
      </Text>
    </View>
  );
}

function SignatureLine({ label, signatureSrc }) {
  const safeSig = isSafeImageSrc(signatureSrc) ? signatureSrc : null;

  return (
    <View style={{ flexDirection: "row", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
      <Text style={{ fontSize: 11 }}>{label}</Text>

      <View
        style={{
          width: 220,
          height: 45,
          borderBottomWidth: 1,
          borderBottomColor: "#111827",
          borderStyle: "dotted",
          justifyContent: "flex-end",
        }}
      >
        {safeSig ? (
          <Image src={safeSig} style={{ width: "100%", height: 45, objectFit: "contain" }} />
        ) : null}
      </View>
    </View>
  );
}

export default function ClientFormBonDeComandaPdfTemplate({ data, companyInfo }) {
  const produs = data?.produsReceptionat?.value || data?.produsReceptionat;
  const produsAltul = safe(data?.produsAltulText);
  const marca = safe(data?.marca);
  const model = safe(data?.model);
  const anFabricatie = safe(data?.anFabricatie);
  const produsAltulChecked = produs === "altul" || (produsAltul && produsAltul.trim().length > 0);
  const stare = data?.stareProdusLaReceptie || [];
  const stareAltul = safe(data?.stareAltulText);
  const oper = data?.operatiuneSolicitata || [];
  const operAltul = safe(data?.operatiuneAltulText);
  const logoSrc = hardcodedLogo;
  const telefonMagazin = safe(data?.telefonMagazin);
  const email = safe(data?.email);
  const adresa = safe(data?.adresaPctLucru);
  const operator = safe(data?.operator);
  const employer = safe(data?.employer);
  const dataComanda = safe(data?.data);
  const ora = safe(data?.ora);
  const client = safe(data?.client);
  const telefonClient = safe(data?.telefon);
  const estimareVal = safe(data?.estimareDurataValue);
  const estimareUnit = safe(data?.estimareDurataUnit?.label || data?.estimareDurataUnit?.value);
  const pret = safe(data?.pretEstimat);
  const risksGroups = Array.isArray(data?.RISKS_GROUPS) ? data.RISKS_GROUPS : [];
  const observatii = safe(data?.riscuriObservatii);
  const clientSig = data?.clientSignature || null;
  const employeeSig = data?.employeeSignature || null;
  const receipt = safe(data?.receipt);
  const receiptDate = safe(data?.receiptDate);
  const confirmReceptionSig = data.clientConfirmSignature || null;
  const confirmReceptionDate = safe(data?.clientConfirmDate);

  return (
    <Document>
      <Page size="A4" style={{ ...base.page, padding: 42 }}>

        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 16,
          }}
        >
          <View style={{ width: "45%", height: 130 }}>
            <Image
              src={logoSrc}
              style={{
                width: 180,
                height: 130,
                objectFit: "contain",
              }}
            />
          </View>


          <View style={{ width: "50%", marginTop: 30 }}>
            <Text style={{ fontSize: 11, marginBottom: 6 }}>
              <Text style={{ fontWeight: "bold" }}>Telefon magazin:</Text> {telefonMagazin}
            </Text>
            <Text style={{ fontSize: 11, marginBottom: 6 }}>
              <Text style={{ fontWeight: "bold" }}>Email:</Text> {email}
            </Text>
            <Text style={{ fontSize: 11 }}>
              <Text style={{ fontWeight: "bold" }}>Adresa pct. de lucru:</Text> {adresa}
            </Text>
          </View>
        </View>

        {/* Title */}
        <View style={{ alignItems: "center", marginBottom: 14 }}>
          <Text style={{ fontSize: 18, fontWeight: "bold" }}>BON DE COMANDĂ</Text>
          <Text style={{ fontSize: 11, marginTop: 2, fontWeight: "bold" }}>Fișă service</Text>
        </View>

        <View style={{ marginBottom: 10 }}>
          <Text style={{ fontSize: 11, marginBottom: 4 }}>Conform bonului fiscal se confirmă recepția produsului</Text>
          <Line label="Număr bon:" value={receipt} />
          {receiptDate ? <Line label="Data bon:" value={receiptDate} /> : null}
        </View>

        {/* Date comandă */}
        <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 8 }}>Date comandă</Text>
        <Line label="Operator: " value={operator} />
        <Line label="Angajator: " value={employer} />
        <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: 6 }}>
          <Text style={{ fontSize: 11 }}>
            Data:{" "}
            <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
              {dataComanda || "____/____/______"}
            </Text>
          </Text>
          <Text style={{ fontSize: 11 }}>
            Ora:{" "}
            <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
              {ora || "_______"}
            </Text>
          </Text>
        </View>
        <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: 12 }}>
          <View style={{ width: "60%" }}>
            <Text style={{ fontSize: 11 }}>
              Client:{" "}
              <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
                {client || "____________________"}
              </Text>
            </Text>
          </View>

          <View style={{ width: "35%", alignItems: "flex-end" }}>
            {telefonClient.trim().length > 0 ? (
              <Text style={{ fontSize: 11 }}>
                Telefon:{" "}
                <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
                  {telefonClient}
                </Text>
              </Text>
            ) : null}
          </View>
        </View>

        {/* Produs recepționat */}
        <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 8 }}>Produs recepționat</Text>
        <Checkbox checked={produs === "cheie_auto_cu_telecomanda"} label="Cheie auto cu telecomandă" />
        <Checkbox checked={produs === "cheie_auto_valet"} label="Cheie auto valet" />
        <Checkbox checked={produs === "telecomanda_rezidentiala_cod_fix"} label="Telecomandă rezidențială Cod fix" />
        <Checkbox checked={produs === "telecomanda_rezidentiala_procedura_oem"} label="Telecomandă rezidențială Procedură OEM" />
        <Checkbox checked={produs === "telecomanda_rezidentiala_procedura_als"} label="Telecomandă rezidențială Procedură ALS" />
        <Checkbox checked={produs === "cheie_rezidentiala_plana"} label="Cheie rezidențială plană" />
        <Checkbox checked={produs === "cheie_rezidentiala_amprenta"} label="Cheie rezidențială amprentă" />
        <Checkbox checked={produs === "cheie_rezidentiala_fluture"} label="Cheie rezidențială fluture" />
        <Checkbox checked={produs === "cheie_rezidentiala_speciala"} label="Cheie rezidențială specială" />
        <Checkbox
          checked={produsAltulChecked}
          label={`Altul: ${produsAltulChecked ? produsAltul : ""}`}
        />

        <Line label="Marca:" value={marca} />
        <Line label="Model:" value={model} />
        <Line label="An fabricație:" value={anFabricatie} />

        <Spacer />

        {/* Stare produs */}
        <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 8 }}>Stare produs la recepție</Text>
        <Checkbox checked={hasValue(stare, "fara_defecte_vizibile")} label="Fără defecte vizibile" />
        <Checkbox checked={hasValue(stare, "probleme_transponder")} label="Probleme la transponder" />
        <Checkbox
          checked={hasValue(stare, "probleme_functia_telecomanda")}
          label="Probleme la funcția de telecomandă"
        />
        <Checkbox checked={hasValue(stare, "carcasa_deteriorata")} label="Carcasă deteriorată" />
        <Checkbox checked={hasValue(stare, "buton_defect")} label="Buton defect" />
        <Checkbox checked={hasValue(stare, "lamela_uzata_rupta")} label="Lamelă/ cheie rezidențială uzată/ruptă/non-OEM" />
        <Checkbox
          checked={altChecked(stare, stareAltul)}
          label={`Altul: ${altChecked(stare, stareAltul) ? stareAltul : ""}`}
        />

        <Spacer />

        {/* Operațiune solicitată */}
        <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 8 }}>Operațiune solicitată</Text>
        <Checkbox
          checked={hasValue(oper, "copiere_cheie_auto_cu_telecomanda")}
          label="Copiere cheie auto cu telecomanda"
        />
        <Checkbox
          checked={hasValue(oper, "copiere_cheie_cu_transponder")}
          label="Copiere cheie cu transponder"
        />
        <Checkbox checked={hasValue(oper, "schimbare_carcasa_auto")} label="Schimbare carcasă auto" />
        <Checkbox checked={hasValue(oper, "mutare_transponder_cip")} label="Mutare transponder (cip)" />
        <Checkbox
          checked={hasValue(oper, "schimbare_baterie_telecomanda")}
          label="Schimbare baterie telecomanda"
        />
        <Checkbox checked={hasValue(oper, "prelucrare_lamela")} label="Prelucrare lamela" />
        <Checkbox
          checked={hasValue(oper, "lipire_butoane_telecomanda")}
          label="Lipire butoane telecomandă"
        />
        <Checkbox
          checked={hasValue(oper, "reparatii_circuit_electronic")}
          label="Reparații circuit electronic"
        />
        <Checkbox
          checked={hasValue(oper, "prelucrare_cheie_lamela_furnizata_client")}
          label="Prelucrare cheie/lamelă furnizată de client"
        />
        <Checkbox
          checked={hasValue(oper, "schimbare_carcasa_auto_piesa_furnizata_client")}
          label="Schimbare carcasă auto cu piesa furnizată de client"
        />
        <Checkbox
          checked={altChecked(oper, operAltul)}
          label={`Altul: ${altChecked(oper, operAltul) ? operAltul : ""}`}
        />

        <Spacer />

        {/* Estimare și preț */}
        <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 8 }}>Estimare și preț</Text>
        <Text style={{ fontSize: 11, marginBottom: 6 }}>
          Estimare durată:{" "}
          <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
            {estimareVal || "______"} {estimareUnit || "minute/ore/zile"}
          </Text>
        </Text>
        <Text style={{ fontSize: 11, marginBottom: 10 }}>
          Preț estimat:{" "}
          <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
            {pret || "______"} lei (include TVA)
          </Text>
        </Text>

        {/* Riscuri */}
        <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 8 }}>Riscuri specifice intervenției, aduse la cunoștință și acceptate de client.</Text>
        {risksGroups.map((group, gi) => (
          <View key={gi} style={{ marginBottom: 8 }}>
            <Text style={{ fontSize: 10.5, fontWeight: "bold", marginBottom: 3 }}>{group.title}</Text>
            {(group.items || []).map((r, idx) => (
              <Text key={idx} style={{ fontSize: 10.5, marginBottom: 3 }}>
                - {r}
              </Text>
            ))}
          </View>
        ))}
        <Text style={{ fontSize: 10.5, marginTop: 6 }}>
          <Text style={{ fontWeight: "bold" }}>Alte observații:</Text>{" "}
          <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
            {observatii || "___________________________________________"}
          </Text>
        </Text>

        <Spacer />

        {/* Declarație client */}
        <Text style={{ fontSize: 12, fontWeight: "bold", marginBottom: 6 }}>Declarație client</Text>
        <Checkbox checked={true} label="Am luat la cunoștință riscurile și sunt de acord cu efectuarea lucrării." />
        <Checkbox checked={true} label="Prin semnarea prezentului document, sunt de acord ca Silca Centre Profesionale de copiat Chei să colecteze și să prelucreze datele mele cu caracter personal (nume și număr de telefon) exclusiv în scopul prestării serviciului solicitat și pentru notificări legate de starea comenzii. Datele vor fi stocate pe durata prevăzută de legislația fiscală și nu vor fi transmise către terți. Conform Regulamentului (UE) 2016/679, aveți dreptul de acces, rectificare sau ștergere a datelor, contactându-ne la adresa de email specificată în antet." />

        <View style={{ flexDirection: "row", justifyContent: "space-between", marginBottom: 14 }}>
          <SignatureLine label="Semnătura client: " signatureSrc={clientSig} />
          <Text style={{ fontSize: 11 }}>
              Operator:{" "}
              <Text style={{ textDecoration: "underline", textDecorationStyle: "dotted" }}>
                {operator || "_____________________"}
              </Text>
            </Text>
        </View>
      </Page>
    </Document>
  );
}

function Spacer() {
  return <View style={{ marginVertical: 10, borderBottomWidth: 1, borderBottomColor: "#e5e7eb" }} />;
}
